import axios from 'axios';

// Relative path -- Front Door routes /quicklink/api/* to the backend origin.
// Same-origin in production (no CORS needed there); against localhost:3001
// during local dev, set REACT_APP_API_BASE to override.
const BASE = process.env.REACT_APP_API_BASE || '/quicklink/api';

export async function getLinks(token) {
  const res = await axios.get(`${BASE}/links`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

export async function createLink(token, data) {
  const res = await axios.post(`${BASE}/links`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

export async function updateLink(token, slug, data) {
  const res = await axios.put(`${BASE}/links/${slug}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

export async function deleteLink(token, slug) {
  const res = await axios.delete(`${BASE}/links/${slug}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}

export async function getAudit(token, slug) {
  const res = await axios.get(`${BASE}/audit/${slug}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
}
